import React, { createContext, useContext, useState } from 'react';

export type ThemeMode = 'light' | 'dark';

const ThemeContext = createContext<{
    mode: ThemeMode;
    resolvedMode: 'light' | 'dark';
    setMode: (mode: ThemeMode) => void;
}>({ mode: 'light', resolvedMode: 'light', setMode: () => {} });

export const useTheme = () => useContext(ThemeContext);

const COOKIE_NAME = 'fortaleza_theme';

const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
};

const setCookie = (name: string, value: string, days: number = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const getSavedTheme = (): ThemeMode => {
    const saved = getCookie(COOKIE_NAME);
    if (saved === 'light' || saved === 'dark') {
        return saved;
    }
    return 'light';
};


export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [mode, setModeState] = useState<ThemeMode>(getSavedTheme);

    const setMode = (newMode: ThemeMode) => {
        setModeState(newMode);
        setCookie(COOKIE_NAME, newMode);
    };

    const resolvedMode: 'light' | 'dark' = mode;

    return (
        <ThemeContext.Provider value={{ mode, resolvedMode, setMode }}>
            {children}
        </ThemeContext.Provider>
    );
};
